import Vue from 'vue'

export function setCreditCard (state, data) {
    if (data) {
        state.creditCard = { ...data }
    } else {
        state.creditCard = null
    }
}

export function setCreditCardSecurity (state, data) {
    if (data) {
        Vue.set(state.creditCard, 'security', data)
    } else {
        Vue.set(state.creditCard, 'security', null)
    }
}

export function setCreditCardExpiration (state, data) {
    if (data) {
        Vue.set(state.creditCard, 'expiration', data)
    } else {
        Vue.set(state.creditCard, 'expiration', null)
    }
}

export function setCreditCardNumber (state, data) {
    if (data) {
        Vue.set(state.creditCard, 'cardNumber', data.raw)
        Vue.set(state.creditCard, 'cardNumberMasked', data.masked)
    } else {
        Vue.set(state.creditCard, 'cardNumber', null)
        Vue.set(state.creditCard, 'cardNumberMasked', null)
    }
}

// export function setCreditCardOwnerBirthday (state, data) {
//     if (data) {
//         Vue.set(state.creditCard, 'ownerBirthday', data)
//     } else {
//         Vue.set(state.creditCard, 'ownerBirthday', null)
//     }
// }

export function setCreditCardOwnerDocument (state, data) {
    if (data) {
        Vue.set(state.creditCard, 'ownerDocument', data)
    } else {
        Vue.set(state.creditCard, 'ownerDocument', null)
    }
}

export function setCreditCardOwnerName (state, data) {
    if (data) {
        Vue.set(state.creditCard, 'ownerName', data)
    } else {
        Vue.set(state.creditCard, 'ownerName', null)
    }
}

export function setCreditCardCoupon (state, data) {
    if (data) {
        Vue.set(state.creditCard, 'coupon', data)
    } else {
        Vue.set(state.creditCard, 'coupon', null)
    }
}

export function setQuantityInstallment (state, data) {
    if (data) {
        Vue.set(state.creditCard, 'quantityInstallment', data)
    } else {
        Vue.set(state.creditCard, 'quantityInstallment', null)
    }
}

export function setDefaultInstallmentsList (state, data) {
    if (data) {
        Vue.set(state.creditCard, 'defaultInstallmentsList', data)
    } else {
        Vue.set(state.creditCard, 'defaultInstallmentsList', null)
    }
}

export function setInstallmentsList (state, data) {
    if (data) {
        Vue.set(state.creditCard, 'installmentsList', data)
    } else {
        Vue.set(state.creditCard, 'installmentsList', null)
    }
}